import {Column} from 'react-table'
import {DataHrItem} from '../../core/_models'
import {HrCustomHeader} from './HrCustomHeader'
import {HrItemValue} from './HrItemValue'
import {HrItemEmployee} from './HrItemEmployee'

const HrColumns: Column<DataHrItem>[] = [
  {
    Header: (props) => <HrCustomHeader tableProps={props} title='время / день' className='min-w-250px text-warning' />,
    accessor: 'hour',
    Cell: ({...props}) => <HrItemEmployee data={props.data[props.row.index].hour} />,
  },
  {
    Header: (props) => (
      <HrCustomHeader tableProps={props} title='пн' className='min-w-125px text-gray-700 text-center' />
    ),
    accessor: 'monday',
    Cell: ({...props}) => <HrItemValue data={props.data[props.row.index].monday} />,
  },
  {
    Header: (props) => (
      <HrCustomHeader tableProps={props} title='вт' className='min-w-125px text-gray-700 text-center' />
    ),
    accessor: 'tuesday',
    Cell: ({...props}) => <HrItemValue data={props.data[props.row.index].tuesday} />,
  },
  {
    Header: (props) => (
      <HrCustomHeader tableProps={props} title='ср' className='min-w-125px text-gray-700 text-center' />
    ),
    accessor: 'wednesday',
    Cell: ({...props}) => <HrItemValue data={props.data[props.row.index].wednesday} />,
  },
  {
    Header: (props) => (
      <HrCustomHeader tableProps={props} title='чт' className='min-w-125px text-gray-700 text-center' />
    ),
    accessor: 'thursday',
    Cell: ({...props}) => <HrItemValue data={props.data[props.row.index].thursday} />,
  },
  {
    Header: (props) => (
      <HrCustomHeader tableProps={props} title='пт' className='min-w-125px text-gray-700 text-center' />
    ),
    accessor: 'friday',
    Cell: ({...props}) => <HrItemValue data={props.data[props.row.index].friday} />,
  },
  {
    Header: (props) => <HrCustomHeader tableProps={props} title='сб' className='min-w-125px text-danger text-center' />,
    accessor: 'saturday',
    Cell: ({...props}) => <HrItemValue data={props.data[props.row.index].saturday} />,
  },
  {
    Header: (props) => <HrCustomHeader tableProps={props} title='вс' className='min-w-125px text-danger text-center' />,
    accessor: 'sunday',
    Cell: ({...props}) => <HrItemValue data={props.data[props.row.index].sunday} />,
  },
]

export {HrColumns}
